import React, { useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  value: PropTypes.string.isRequired,
}

const defaultProps = {

}

// Polaris version doesn't have component for Label directly, emulate classes used
const AppLabel = ({ value }) => {
  return (
    <div className="Polaris-Labelled__LabelWrapper">
      <div className="Polaris-Label">
        <label className="Polaris-Label__Text">
          { value }
        </label>
      </div>
    </div>
  )
};

AppLabel.propTypes = propTypes;
AppLabel.defaultProps = defaultProps;

export default AppLabel;